import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const joinParts = (parts) =>
  parts.length <= 1
    ? parts.join("")
    : `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}`;

const SyncDatesDialog = ({
  open,
  challengeCount,
  songCount,
  danceCount = 0,
  updating,
  onSkip,
  onUpdate,
}) => {
  const parts = [];
  if (challengeCount) {
    parts.push(`${challengeCount} challenge${challengeCount === 1 ? "" : "s"}`);
  }
  if (songCount) {
    parts.push(`${songCount} song${songCount === 1 ? "" : "s"}`);
  }
  if (danceCount) {
    parts.push(`${danceCount} dance${danceCount === 1 ? "" : "s"}`);
  }

  return (
    <Dialog
      open={open}
      onClose={updating ? undefined : onSkip}
      maxWidth="xs"
      fullWidth
      sx={{ zIndex: 1400 }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>Update linked content?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Theme dates changed. Update {joinParts(parts)} so their start and
          end match this theme?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onSkip} disabled={updating} sx={{ textTransform: "none" }}>
          Skip
        </Button>
        <Button
          variant="contained"
          onClick={onUpdate}
          disabled={updating}
          sx={{
            textTransform: "none",
            backgroundColor: "#142C5C",
            "&:hover": { backgroundColor: "#0f2247" },
          }}
        >
          {updating ? "Updating..." : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SyncDatesDialog;
